import React, { memo } from "react";
import "./styles.scss";

const StyledCalenderField = ({
  onChange = () => {},
  name = "",
  value = "",
  label = "",
  shouldSetMinData = false,
  minDate = "",
  shouldSetMaxDate = false,
  maxDate = "",
  marginBottom = 0,
  disabled = false,
  errorMessage = "",
}) => {
  return (
    <div
      className="calender-select-field"
      style={{ padding: "0px", marginBottom: marginBottom }}
    >
      {label.length && <div className="label-styles">{label}</div>}
      <input
        type="date"
        name={name}
        value={value}
        disabled={disabled}
        class="form-control"
        min={shouldSetMinData ? minDate : ""}
        max={shouldSetMaxDate ? maxDate : ""}
        id="date"
        style={{
          background: "white",
        }}
        onChange={onChange}
      />
      {errorMessage?.length ? (
        <div style={{ fontSize: "11px", fontWeight: 500, color: "red" }}>
          {errorMessage}
        </div>
      ) : (
        ""
      )}
    </div>
  );
};

export default memo(StyledCalenderField);
